import { CloseIcon } from '~components/icons'
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
} from '@mui/material'
import React from 'react'
import useBreakpoint from '~hooks/use-breakpoint'

interface DialogWrapperProps {
  onClose: () => void
  onDownload: () => void
  showFullScreen?: boolean
  title?: string
  children: React.ReactNode
}

export const DialogWrapper: React.FC<DialogWrapperProps> = ({
  onClose,
  onDownload,
  showFullScreen,
  title,
  children,
}) => {
  const { isMobileSize } = useBreakpoint()
  return (
    <Dialog
      fullScreen={showFullScreen}
      onClose={onClose}
      open
      sx={{
        mt: isMobileSize ? 0 : 8,
        mb: isMobileSize ? 0 : 11,
        mx: isMobileSize ? 0 : 10,
      }}
    >
      {!isMobileSize && (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      )}
      <DialogTitle>{title}</DialogTitle>
      {children}
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
        <Button variant="contained" onClick={onDownload}>
          Download
        </Button>
      </DialogActions>
    </Dialog>
  )
}
